import { api } from './api';
import { RewardsConfig, CourseBadgeMapping, Lottery, LotteryTicket, VirtualGood, BadgeInfo } from 'types';

export async function getRewardsConfig(): Promise<RewardsConfig | null> {
  try {
    const { data } = await api.get('database/appearance__c');
    if (!Array.isArray(data) || !data.length || !data[0].rewards) return null;
    return data[0].rewards as RewardsConfig;
  } catch {
    return null;
  }
}

export async function getCourseBadgeMappings(): Promise<CourseBadgeMapping[]> {
  try {
    const { data } = await api.get('database/courses_badges__c');
    if (!Array.isArray(data)) return [];
    return data as CourseBadgeMapping[];
  } catch {
    return [];
  }
}

export async function getLotteries(): Promise<Lottery[]> {
  try {
    const { data } = await api.get('/lottery');
    if (!Array.isArray(data)) return [];
    return data as Lottery[];
  } catch {
    return [];
  }
}

export async function generateLotteryTicket(lotteryId: string, playerId: string): Promise<LotteryTicket | null> {
  try {
    const { data } = await api.post('/lottery/ticket', {
      lottery: lotteryId,
      player: playerId,
    });
    return data as LotteryTicket;
  } catch {
    return null;
  }
}

export async function getPlayerTickets(playerId: string): Promise<LotteryTicket[]> {
  try {
    const { data } = await api.get('/lottery/ticket', {
      params: {
        q: `'player':'${playerId}'`,
      },
    });
    if (!Array.isArray(data)) return [];
    return data as LotteryTicket[];
  } catch {
    return [];
  }
}

export async function getLotteryPrizes(): Promise<VirtualGood[]> {
  try {
    const { data } = await api.get('/virtualgoods/item');
    if (!Array.isArray(data)) return [];
    return data as VirtualGood[];
  } catch {
    return [];
  }
}

export async function getBadgeById(badgeId: string): Promise<BadgeInfo | null> {
  try {
    const { data } = await api.get(`/challenge/${badgeId}`);
    return data as BadgeInfo;
  } catch {
    return null;
  }
}

export async function logCheckpointAction(actionId: string, userId: string, attributes: Record<string, any>): Promise<any> {
  try {
    const { data } = await api.post('/action/log/bulk', [
      {
        actionId,
        userId,
        attributes,
      },
    ]);
    return data;
  } catch {
    return null;
  }
}

export async function getLotteryResults(lotteryId: string, playerId: string): Promise<any[]> {
  try {
    const { data } = await api.post('database/achievement/aggregate', [
      { $match: { type: 5, item: lotteryId } },
      { $lookup: { from: 'player', localField: 'player', foreignField: '_id', as: 'p' } },
      { $unwind: '$p' },
      { $lookup: { from: 'lottery', localField: 'item', foreignField: '_id', as: 'l' } },
      { $unwind: '$l' },
      {
        $project: {
          _id: 1,
          player: 1,
          player_name: '$p.name',
          player_email: '$p.email',
          player_image: '$p.image.original.url',
          player_extra: '$p.extra',
          lottery: '$l._id',
          lottery_ticket: '$extra.ticket',
          lottery_title: '$l.title',
          time: 1,
        },
      },
      { $match: { player: playerId } },
    ]);
    return Array.isArray(data) ? data : [];
  } catch (err) {
    console.error('Erro ao buscar resultados da loteria:', err);
    return [];
  }
}
